/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react';
import {useRouter} from 'next/router';

import Link from './Link';
import {CourseVisits} from '../../../lib/constants/courses';
import {AcademicCapIcon, StoryBookIcon} from './svg';
import {clampLines, createURLWithParams} from '../util';

const CourseCard = ({
  course, trackerEvent, urlParams, showThumbnail = true, showDescription = true,
}) => {
  const router = useRouter();
  const url = `/courses/${course.slug}`;

  const handleClick = () => {
    trackerEvent?.();
    router.push(createURLWithParams(url, urlParams));
  };

  return (
    <div
      onClick={handleClick}
      className="cursor-pointer py-3 px-5 border border-gray-200 rounded-lg hover:border-gray-300 transition duration-50 overflow-hidden"
    >
      {showThumbnail && (
        <div className="hidden md:flex flex-col w-full">
          <div className="flex relative -mt-3 -mx-5 mb-5 h-36 justify-center items-center bg-gray-100">
            {course.thumbnail
              ? (
                <img
                  src={`${course.thumbnail}?w=800&h=800`}
                  className="w-full h-full object-cover"
                  loading="lazy"
                  width="400"
                  height="200"
                  alt={course.title}
                />
              ) : <StoryBookIcon className="w-10 h-10 text-gray-400" />}
            <div className="absolute inset-0 w-full h-full bg-gray-200 bg-opacity-10" />
          </div>
        </div>
      )}
      <div className="flex flex-col justify-between w-full">
        <Link href={url}>
          <h3 className="text-xl font-semibold mb-2">{course.shortTitle}</h3>
        </Link>
        <div className="mb-2 flex items-center space-x-2 text-sm font-medium text-gray-500">
          <span className="flex items-center">
            <StoryBookIcon className="h-5 mr-1" />
            {course.contentType === 'track' ? `${course.numCourses || course.courses?.length} courses` : `${course.numLessons || course.lessons?.length} lessons`}
          </span>
          {CourseVisits[course.slug] && (
            <span className="flex items-center">
              <AcademicCapIcon className="h-4 mr-1" />
              {`${(Math.round(CourseVisits[course.slug] / 100) * 100).toLocaleString()} students`}
            </span>
          )}
        </div>
        {showDescription && (
          <p
            className="text-gray-500 mb-3 md:mb-6"
            style={clampLines(3)}
          >
            {course.description}
          </p>
        )}
      </div>
    </div>
  );
};

export default CourseCard;
